import { ExpiryDateFormatter } from 'field-kit';
export default class ExpirationDateFormatter extends ExpiryDateFormatter {
  /**
   * The parse function in ExpiryDateFormatter parses the values into an object as:
   * {
   *   month: number;
   *   year: number;
   * }
   *
   * Bizbank FinishCardActivationRequest requires the expiration date to be formatted as MMYY.
   */
  parse(text, error) {
    if (text.length === this.maximumLength) {
      return text.replace(this.delimiter, '');
    }
    if (typeof error === 'function') {
      error('expiry-date-formatter.invalid-date');
    }
    return '';
  }
}